module.exports = __webpack_public_path__ + "img/zleft.bf2ab18d.png";